export class Contract {
    id: number;
    company: string;
    description: string;
  }